export default __webpack_public_path__ + "static/TravelDemandManagementTDM-7bf502da74e92cdfbdd7df423a34c57f.png";